import { functions } from 'utility/appwriteClient';

const preferredLogic = async (tenant: any, packageData: any, orderData: any) => {
    try {
        const shippingMethodResponse = await functions.createExecution(
            'getPreferredLogic',
            JSON.stringify({ 
                tenant: tenant,
                packageData : {
                    state: packageData.state,
                    postcode: packageData.postcode
                },
                orderData : {
                    description: orderData.Description
                }
            })
        );
        
        const responseData = JSON.parse(shippingMethodResponse.response);
        
        return responseData.shippingMethod;
        
    } catch (error) {
        console.error("Error fetching preferred logic data:", error);
    }

    return "";
}

const addOnLogic = (packageData: any, orderData: any, shippingData: any) => {
    
    var returnData = []

    if (orderData.CentreID === "10312" && orderData.DeliveryType.Name === ("ToCustomer") && orderData.OrderNonCentreDeliveries[0].Address.CompanyName.includes('Officeworks IQ')) {
        returnData.push({ "Name": "Officeworks IQ" })
    }

    if (shippingData === 'STEFPP') {
        returnData.push({ "Name": "Air" })
    }

    return (
        returnData
    )

}

export { preferredLogic, addOnLogic };